import { z } from 'zod';
import { Validation } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import {
    PromotedServiceAssignmentReservationIntervalLimit,
    PromotedServiceAssignmentUnitCountLimit,
} from '@mews-commander/data-access';

export enum FormFields {
    PromotedServiceId = 'promotedServiceId',
    Enabled = 'enabled',
    PromotedResourceCategoryId = 'promotedResourceCategoryId',
    PromotedRateId = 'promotedRateId',
    Description = 'description',
    Options = 'promotedServiceAssignmentOptions',
    UnitCountLimit = 'unitCountLimit',
    ReservationIntervalLimit = 'reservationIntervalLimit',
    Ordering = 'ordering',
}

export enum OptionsNames {
    InBookingEnging = 'offerInBookingEngine',
    DuringOnlineCheckin = 'offerDuringOnlineCheckIn',
}

export const servicePromotionSchema = z.object({
    [FormFields.Enabled]: z.boolean(),
    [FormFields.PromotedServiceId]: Validation.String.Required,
    [FormFields.PromotedResourceCategoryId]: z
        .string()
        .trim()
        .min(1, { message: TextKey.PromotedServiceAssignmentResourceCategoryRequiredErrorMessage }),
    [FormFields.PromotedRateId]: z
        .string()
        .trim()
        .min(1, { message: TextKey.PromotedServiceAssignmentFormErrorMessageNoRate }),
    [FormFields.Description]: z.string().optional(),
    [FormFields.Options]: z
        .array(z.nativeEnum(OptionsNames))
        .min(1, { message: TextKey.PromotedServiceAssignmentOptionsOfferErrorMessage }),
    [FormFields.UnitCountLimit]: z.nativeEnum(PromotedServiceAssignmentUnitCountLimit),
    [FormFields.ReservationIntervalLimit]: z.nativeEnum(PromotedServiceAssignmentReservationIntervalLimit),
    [FormFields.Ordering]: z.number().int(),
});

export type FormValues = z.infer<typeof servicePromotionSchema>;
